// Presentation metadata only. Calculations remain in the shared API.
const config = { fields: [], initialMessage: 'Enter fund rates and allocations totalling 100%.' };
export default config;
